import { IncomeTypeEnum } from '@app/enums/income-type.enum';

export interface FormControlToEnumTypeMapping<E> {
    [formControlName: string]: E[];
}

export class IncomeBeforeOfferConfig {
    public showInputOnTypes: FormControlToEnumTypeMapping<IncomeTypeEnum> = {
        amount: [
            IncomeTypeEnum.turnoverIncome,
            IncomeTypeEnum.fixedTermEmployment,
            IncomeTypeEnum.indefinitePeriodEmployment,
            IncomeTypeEnum.selfEmployment,
            IncomeTypeEnum.pension,
            IncomeTypeEnum.futureRentalRevenue,
            IncomeTypeEnum.rentalIncomeOutsideTaxReturn,
            IncomeTypeEnum.childBenefit,
            IncomeTypeEnum.disabilityPension1,
            IncomeTypeEnum.disabilityPension2,
            IncomeTypeEnum.disabilityPension3,
            IncomeTypeEnum.retirementAnnuity,
            IncomeTypeEnum.parentalContribution,
            IncomeTypeEnum.maternityContribution,
            IncomeTypeEnum.fosterCareAllowance,
            IncomeTypeEnum.diet,
            IncomeTypeEnum.orphanPension,
            IncomeTypeEnum.widowPension,
            IncomeTypeEnum.alimony,
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.indefiniteActionAgreement,
            IncomeTypeEnum.employmentAgreement,
            IncomeTypeEnum.indefiniteEmploymentAgreement,
            IncomeTypeEnum.capitalIncome,
            IncomeTypeEnum.shareOfProfits,
            IncomeTypeEnum.other,
        ],
        fromDate: [
            IncomeTypeEnum.fixedTermEmployment,
            IncomeTypeEnum.indefinitePeriodEmployment,
            IncomeTypeEnum.selfEmployment,
            IncomeTypeEnum.rentalIncomeOutsideTaxReturn,
            IncomeTypeEnum.parentalContribution,
            IncomeTypeEnum.maternityContribution,
            IncomeTypeEnum.fosterCareAllowance,
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.indefiniteActionAgreement,
            IncomeTypeEnum.employmentAgreement,
            IncomeTypeEnum.indefiniteEmploymentAgreement,
            IncomeTypeEnum.futureRentalRevenue,
            IncomeTypeEnum.rentalIncome,
        ],
        untilDate: [
            IncomeTypeEnum.fixedTermEmployment,
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.employmentAgreement,
            IncomeTypeEnum.rentalIncome,
            IncomeTypeEnum.futureRentalRevenue,
            IncomeTypeEnum.rentalIncomeOutsideTaxReturn,
        ],
        isTrialPeriod: [
            IncomeTypeEnum.fixedTermEmployment,
            IncomeTypeEnum.indefinitePeriodEmployment,
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.indefiniteActionAgreement,
            IncomeTypeEnum.employmentAgreement,
            IncomeTypeEnum.indefiniteEmploymentAgreement,
        ],
        isNoticePeriod: [
            IncomeTypeEnum.fixedTermEmployment,
            IncomeTypeEnum.indefinitePeriodEmployment,
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.indefiniteActionAgreement,
            IncomeTypeEnum.employmentAgreement,
            IncomeTypeEnum.indefiniteEmploymentAgreement,
        ],
        isSubsequent: [
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.indefiniteActionAgreement,
            IncomeTypeEnum.employmentAgreement,
            IncomeTypeEnum.indefiniteEmploymentAgreement,
            IncomeTypeEnum.indefinitePeriodEmployment,
        ],
        'source.name': [
            IncomeTypeEnum.fixedTermEmployment,
            IncomeTypeEnum.indefinitePeriodEmployment,
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.indefiniteActionAgreement,
            IncomeTypeEnum.employmentAgreement,
            IncomeTypeEnum.indefiniteEmploymentAgreement,
            IncomeTypeEnum.diet,
            IncomeTypeEnum.selfEmployment,
            IncomeTypeEnum.pension,
            IncomeTypeEnum.childBenefit,
            IncomeTypeEnum.disabilityPension1,
            IncomeTypeEnum.disabilityPension2,
            IncomeTypeEnum.disabilityPension3,
            IncomeTypeEnum.retirementAnnuity,
            IncomeTypeEnum.parentalContribution,
            IncomeTypeEnum.maternityContribution,
            IncomeTypeEnum.fosterCareAllowance,
            IncomeTypeEnum.orphanPension,
            IncomeTypeEnum.widowPension,
            IncomeTypeEnum.capitalIncome,
            IncomeTypeEnum.shareOfProfits,
            IncomeTypeEnum.turnoverIncome,
            IncomeTypeEnum.other,
        ],
        'source.idNumber': [
            IncomeTypeEnum.fixedTermEmployment,
            IncomeTypeEnum.indefinitePeriodEmployment,
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.indefiniteActionAgreement,
            IncomeTypeEnum.employmentAgreement,
            IncomeTypeEnum.indefiniteEmploymentAgreement,
            IncomeTypeEnum.diet,
            IncomeTypeEnum.selfEmployment,
            IncomeTypeEnum.rentalIncome,
            IncomeTypeEnum.turnoverIncome,
        ],
        costAccounting: [IncomeTypeEnum.selfEmployment],
        row101: [IncomeTypeEnum.selfEmployment],
        'source.naceCode': [IncomeTypeEnum.selfEmployment],
        employmentExtendedCount: [
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.fixedTermEmployment,
            IncomeTypeEnum.employmentAgreement,
        ],
        employmentExtendedSameEmployer: [
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.indefinitePeriodEmployment,
            IncomeTypeEnum.employmentAgreement,
        ],
        employedAtOwnCompany: [
            IncomeTypeEnum.fixedTermEmployment,
            IncomeTypeEnum.indefinitePeriodEmployment,
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.indefiniteActionAgreement,
            IncomeTypeEnum.employmentAgreement,
            IncomeTypeEnum.indefiniteEmploymentAgreement,
        ],
        rentalIncomeType: [IncomeTypeEnum.rentalIncome],
        stoppedInLastTwoYears: [IncomeTypeEnum.selfEmployment],
        contractTermPeriod: [
            IncomeTypeEnum.futureRentalRevenue,
            IncomeTypeEnum.rentalIncomeOutsideTaxReturn,
            IncomeTypeEnum.rentalIncome,
        ],
        professionType: [IncomeTypeEnum.diet],
        shareInTheCompany: [IncomeTypeEnum.turnoverIncome],
        'source.createdAt': [IncomeTypeEnum.turnoverIncome],
    };

    public requiredOnTypes: { [key: string]: string[] } = {
        untilDate: [
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.employmentAgreement,
            IncomeTypeEnum.fixedTermEmployment,
            IncomeTypeEnum.rentalIncomeOutsideTaxReturn,
            IncomeTypeEnum.futureRentalRevenue,
            IncomeTypeEnum.rentalIncome,
        ],
        fromDate: [
            IncomeTypeEnum.fixedTermEmployment,
            IncomeTypeEnum.indefinitePeriodEmployment,
            IncomeTypeEnum.selfEmployment,
            IncomeTypeEnum.pension,
            IncomeTypeEnum.rentalIncome,
            IncomeTypeEnum.futureRentalRevenue,
            IncomeTypeEnum.rentalIncomeOutsideTaxReturn,
            IncomeTypeEnum.childBenefit,
            IncomeTypeEnum.disabilityPension1,
            IncomeTypeEnum.disabilityPension2,
            IncomeTypeEnum.disabilityPension3,
            IncomeTypeEnum.retirementAnnuity,
            IncomeTypeEnum.parentalContribution,
            IncomeTypeEnum.maternityContribution,
            IncomeTypeEnum.fosterCareAllowance,
            IncomeTypeEnum.diet,
            IncomeTypeEnum.orphanPension,
            IncomeTypeEnum.widowPension,
            IncomeTypeEnum.alimony,
            IncomeTypeEnum.actionAgreement,
            IncomeTypeEnum.indefiniteActionAgreement,
            IncomeTypeEnum.employmentAgreement,
            IncomeTypeEnum.indefiniteEmploymentAgreement,
            IncomeTypeEnum.capitalIncome,
            IncomeTypeEnum.shareOfProfits,
            IncomeTypeEnum.other,
        ],
        'source.idNumber': [IncomeTypeEnum.turnoverIncome],
    };

    public nameOnTypes: { [key: string]: { types: string[]; name: string }[] } = {
        'source.name': [
            {
                types: ['default'],
                name: 'Název zaměstnavatele',
            },
            {
                types: [IncomeTypeEnum.turnoverIncome],
                name: 'Název společnosti',
            },
            {
                types: [IncomeTypeEnum.selfEmployment],
                name: 'Název podnikání',
            },
            {
                types: [
                    IncomeTypeEnum.pension,
                    IncomeTypeEnum.childBenefit,
                    IncomeTypeEnum.disabilityPension1,
                    IncomeTypeEnum.disabilityPension2,
                    IncomeTypeEnum.disabilityPension3,
                    IncomeTypeEnum.retirementAnnuity,
                    IncomeTypeEnum.parentalContribution,
                    IncomeTypeEnum.maternityContribution,
                    IncomeTypeEnum.fosterCareAllowance,
                    IncomeTypeEnum.orphanPension,
                    IncomeTypeEnum.widowPension,
                    IncomeTypeEnum.capitalIncome,
                    IncomeTypeEnum.shareOfProfits,
                    IncomeTypeEnum.other,
                ],
                name: 'Vypláceno institucí / firmou',
            },
        ],
        'source.idNumber': [
            {
                types: ['default'],
                name: 'IČO zaměstnavatele',
            },
            {
                types: [IncomeTypeEnum.rentalIncome, IncomeTypeEnum.selfEmployment],
                name: 'IČO podnikání',
            },
            {
                types: [IncomeTypeEnum.turnoverIncome],
                name: 'IČO společnosti',
            },
        ],
        fromDate: [
            {
                types: ['default'],
                name: 'Od data',
            },
            {
                types: [IncomeTypeEnum.turnoverIncome],
                name: 'Je podílníkem od',
            },
        ],
        amount: [
            {
                types: ['default'],
                name: 'Výše příjmu',
            },
            {
                types: [
                    IncomeTypeEnum.rentalIncome,
                    IncomeTypeEnum.futureRentalRevenue,
                    IncomeTypeEnum.rentalIncomeOutsideTaxReturn,
                ],
                name: 'Výše příjmu (čístý nájem bez energií)',
            },
        ],
    };

    public tooltipOnTypes: { [key: string]: { types: string[]; name: string }[] } = {
        amount: [
            {
                types: ['default'],
                name: 'Uveďte částku, která Vám přichází na účet. OSVČ bude vyzván k doložení daňového přiznání.',
            },
            {
                types: [IncomeTypeEnum.turnoverIncome],
                name: 'Uveďte prosím orientační příjem, my Vám ho dopočítáme přesně.  ',
            },
        ],
    };
}
